let cookie = {
  set(key, val, time) {
    var date = new Date();
    var expiresDays = time;
    date.setTime(date.getTime() + expiresDays * 24 * 3600 * 1000);
    document.cookie = key + "=" + val + ";expires=" + date.toGMTString();
  },
    // 获取cokkie
  get(key) {
    var getCookie = document.cookie.replace(/[ ]/g, "");
    var arrCookie = getCookie.split(";");
    var tips;
    for (var i = 0; i < arrCookie.length; i++) {
      var arr = arrCookie[i].split("=");
      if (key == arr[0]) {
        tips = arr[1];
        break;
      }
    }
    return tips;
  },
    // 删除cookie
  delete(key) {
    var date = new Date();
    date.setTime(date.getTime() - 10000);
    document.cookie = key + "=v; expires =" + date.toGMTString();
  },
  getToken(){
    let token = sessionStorage.getItem("token");
    // if (token == null ){
    //   token = cookie.get("token");
    //   if (token != null ){
    //     sessionStorage.setItem("token",token);
    //   }
    // }else {
    //   let  token2 = cookie.get("token");
    //   if(token2 == null){
    //     sessionStorage.removeItem("menu");
    //     sessionStorage.removeItem("menu");
    //     sessionStorage.removeItem("menuActive");
    //     sessionStorage.removeItem("token");
    //     token = null;
    //   }
    // }
    //
    // if (token) {
    //   token = "Bearer " + token;
    // }
    return token;
  },


  getBearerToken(){
    let token = this.getToken();
    return token ? `Bearer ${token}` : null;
  }
};
export default cookie;
